<template>
  <div class="login-new">
    <!-- 背景图 -->
    <bgList v-if="pageConfig.loginPageBackground" :list="pageConfig.loginPageBackground"></bgList>
    <!-- LOGO -->
    <div class="logo">
      <img v-show="pageConfig.showPageLogo && titleAlign === 'top'" :src="logoUrl" alt="">
      <div ref="titleTextTop" class="top-title-text" v-show="titleAlign === 'top'">
        {{pageConfig.loginPageTitle}}</div>
    </div>
    <!-- 登录框 -->
    <div class="text-place">
      <div class="title-text" :class="titleAlign" ref="titleText">
        <img v-show="pageConfig.showPageLogo && titleAlign === 'left'" :src="logoUrl" alt="">
        <div style="margin-bottom: 20px;" v-if="pageConfig.loginPageStyle === 1">{{pageConfig.customText}}</div>
        <div style="vertical-align: middle">
          <img style="vertical-align: middle" v-show="pageConfig.showPageLogo && titleAlign === 'center'" :src="logoUrl" alt="">
          {{pageConfig.loginPageTitle}}</div>
      </div>
      <div class="illustrator-place" v-if="pageConfig.loginPageStyle === 2">
        <img :src="getRealUrl(pageConfig.illustration)" alt="">
      </div>
      <div class="login-place" :class="loginAlign" v-if="pageConfig">
        <login-box1 v-if="pageConfig.loginBoxStyle === 1" @changeType="handleChangeType" @changeFanjian="getStyleData" class="login-box" :rate="rate" :pageConfig="pageConfig"></login-box1>
        <login-box2 v-if="pageConfig.loginBoxStyle === 2" @changeType="handleChangeType" @changeFanjian="getStyleData" class="login-box" :rate="rate" :pageConfig="pageConfig"></login-box2>
        <login-box3 v-if="pageConfig.loginBoxStyle === 3" @changeType="handleChangeType" @changeFanjian="getStyleData" class="login-box" :rate="rate" :pageConfig="pageConfig"></login-box3>
      </div>
    </div>
    <!-- 底部信息 -->
    <div class="bottom-info" v-if="pageConfig.technicalSupport || pageConfig.recordNumber">
      <span class="recordNumber" v-if="pageConfig.recordNumber">{{ $t('备案序号') }}：
        <a href="https://beian.miit.gov.cn" target="_blank" style="text-decoration: underline;">
            {{ pageConfig.recordNumber }}
        </a>
      </span>
      <span class="technicalSupport" v-if="pageConfig.technicalSupport">{{ $t('技术支持') }}： {{pageConfig.technicalSupport}}</span>
    </div>
  </div>
</template>

<script>
import { imgBaseUrl, changeFavicon, getDomainPrefix } from '@/utils/common'
require('@/utils/qrcode.js')
export default {
  props: {
    loginType: {
      type:Number,
      default:0
    }
  },
  data() {
    return {
      domainPrefix:'',
      logoUrl:'',
      loginAlign:'center',
      titleAlign:'center',
      pageConfig:{

      },
      rate:1,
      pageType:'loginForm'
    }
  },
  components:{
    LoginBox1: () => import('@/views/login/components/loginBox1'),
    LoginBox2: () => import('@/views/login/components/loginBox2'),
    LoginBox3: () => import('@/views/login/components/loginBox3'),
    bgList: () => import('@/views/login/components/bgList')
  },
  mounted() {
    // 查询页面配置
    this.getStyleData()
    this.setRate()
    window.addEventListener('resize', this.setRate)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setRate)
  },
  methods:{
    handleChangeType(type) {
      this.pageType = type
    },
    getRealUrl(url){
      if(url) {
        let str = "/image/"
        if (url.indexOf(str) == 0) {
          return url
        } else {
          return imgBaseUrl + url
        }
      }
    },
    getStyleData() {
      let domain = window.location.pathname
      //  domain = "http://dev.everiaction.com/#/login"
      let domainPrefix = getDomainPrefix(domain) || 'origin'
      console.log("domainPrefix", domainPrefix)
      this.domainPrefix = domainPrefix
      this.$httpSys.get("/crm/customizeInfo/pass/findByDomainPrefixAndStyle?domainPrefix="+this.domainPrefix+"&loginStyle="+this.loginType).then(res => {
        if(res.data && res.data.styles && res.data.styles.length > 0) {
            const config = res.data.styles[0]
            config.loginPageBackground = config.loginPageBackground ? config.loginPageBackground.split('|') : ['/image/logobg.jpg']
            config.loginPageTitle = config.loginPageTitle || this.$t('')
            config.customText = config.customText || this.$t('')
            config.technicalSupport = res.data.technicalSupport
            config.recordNumber = res.data.recordNumber
            config.headerSize = config.headerSize || 48
            config.wxCode = res.data.wxCode
            document.title = res.data.platformName;
            changeFavicon(this.getRealUrl(res.data.websiteLogoPath))
            this.logoUrl = (config.logoType === 1? this.getRealUrl(res.data.logoTypeLight) : this.getRealUrl(res.data.logoTypeDeep)) || '/image/logo.png'
            this.pageConfig = config
            this.setLayout()
            this.$store.commit('SET_PAGECONFIG', res.data)
        }else{
          this.pageConfig = {
            loginPageStyle:1,
            loginPageBackground:['/image/logobg.jpg'],
            illustration:'',
            platformNameLocation:1,
            loginBoxStyle:1,
            titleColor:'#ffffff',
            headerSize:'48',
            // loginPageTitle:this.$t('藤州浔江大桥健康监测系统'),
            // customText:'Hi,欢迎进入',
            loginPageTitle:this.$t(''),
            customText:'',
            loginBoxText:'',
            showPageLogo:1,
            logoType:1,
            showQrcode:1,
            showCode:0,
            showRegistAgreement:0,
            showFontSwitch:0,
            loginJumpMethod:"1",
            platformLogoPath:'',
            loginJumpUrl:'',
            technicalSupport:'',
            recordNumber:'',
            wxCode:0
          }
          this.setLayout()
        }
      }).catch(() => {
        this.pageConfig = {
          loginPageStyle:1,
          loginPageBackground:['/image/logobg.jpg'],
          illustration:'',
          platformNameLocation:1,
          loginBoxStyle:1,
          titleColor:'#ffffff',
          headerSize:'48',
          loginPageTitle:this.$t('藤州浔江大桥健康监测系统'),
          customText:'Hi,欢迎进入',
          loginBoxText:'',
          showPageLogo:1,
          logoType:1,
          showQrcode:1,
          showCode:0,
          showRegistAgreement:0,
          showFontSwitch:0,
          loginJumpMethod:"1",
          platformLogoPath:'',
          loginJumpUrl:'',
          technicalSupport:'',
          recordNumber:'',
          wxCode:0
        }
        this.setLayout()
      })
    },
    setLayout() {
      const titleRefStyle = this.$refs.titleText.style
      titleRefStyle.fontSize = this.pageConfig.headerSize + 'px'

      const titleRefTopStyle = this.$refs.titleTextTop.style
      titleRefTopStyle.fontSize = this.pageConfig.headerSize + 'px'

      if(this.pageConfig.loginPageStyle === 1) {
        this.loginAlign = 'right'
        this.titleAlign = 'left'
      }else if(this.pageConfig.loginPageStyle === 2){
        this.loginAlign = 'right'
        this.titleAlign = 'top'
      }else if(this.pageConfig.loginPageStyle === 3){
        this.loginAlign = 'center'
        this.titleAlign = 'center'
        if(this.pageConfig.platformNameLocation === 1) {
          this.titleAlign = 'top'
        }else if(this.pageConfig.platformNameLocation === 2) {
          this.titleAlign = 'center'
          titleRefStyle.marginTop = -this.pageConfig.headerSize * 2 + 'px'
        }
      }
      titleRefStyle.color = this.pageConfig.titleColor
      // titleRefStyle.transform = `scale(${this.rate},${this.rate})`
      // titleRefStyle.webkitTransform = `scale(${this.rate},${this.rate})`
      // titleRefStyle.msTransform = `scale(${this.rate},${this.rate})`

      titleRefTopStyle.color = this.pageConfig.titleColor
      // titleRefTopStyle.transform = `scale(${this.rate},${this.rate})`
      // titleRefTopStyle.webkitTransform = `scale(${this.rate},${this.rate})`
      // titleRefTopStyle.msTransform = `scale(${this.rate},${this.rate})`
    },
    setRate() {
      document.documentElement.style.fontSize = '14px'
      // const height = window.innerHeight
      // this.rate = height / 1080
      // const rate = this.rate
      // if(height < 1080) {
      //   document.documentElement.style.fontSize = (14 / rate) + 'px'
      // }else{
      //   document.documentElement.style.fontSize = (14 * rate) + 'px'
      // }
      // if(this.pageConfig) {
      //   this.setLayout()
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-new {
  position: relative;
  width: 100%;
  height: 100%;
  .logo {
    position: absolute;
    z-index: 10;
    top: 10%;
    left: 10%;
    img{
      vertical-align: middle;
    }
    .top-title-text {
      vertical-align: middle;
      margin-left:20px;
      color: #fff;
      text-shadow: 1px 0 3px #000;
      display: inline-block;
      transform-origin: left;
    }
  }
  .text-place {
    position: absolute;
    z-index: 12;
    top: 50%;
    transform: translateY(-50%);
    width: 80%;
    left: 10%;
    .illustrator-place{
      position: absolute;
      top:50%;
      left:0;
      transform: translateY(-50%);
      img{
        max-height: 68vh;
        width: auto;
        height: 100%;
      }
    }
    .title-text {
      position: absolute;
      color: #fff;
      text-shadow: 1px 0 3px #000;
      &.left {
        height: 100%;
        transform-origin: left;
      }
      &.center {
        transform-origin: center;
        width:100%;
        height:100%;
        text-align: center;
      }
      &.top {
        display: none;
      }
    }
    .login-place{
      &.center {
        .login-box {
          margin:0 auto;
          transform-origin: center;
        }
      }
      &.right {
        float: right;
        .login-box {
          transform-origin: right;
        }
      }
    }
  }
  .bottom-info{
    text-align: center;
    padding: 16px;
    background: rgba(0,0,0,0.2);
    color: rgba(255,255,255,0.8);
    position: absolute;
    bottom: 0;
    z-index:10;
    width:100%;
    .technicalSupport {
      margin:0 10px;
    }
    .recordNumber {
      margin:0 10px;
    }
  }
}
</style>